<template>
  <input
    ref="inputRef"
    v-model="displayValue"
    type="text"
    @input="onInput"
    @click="handleClick"
  />
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue'

// Props
const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: '',
  },
  mask: {
    type: [String, Array],
    required: true,
  },
  masked: {
    type: Boolean,
    default: false,
  },
})

// Emits
const emit = defineEmits(['update:modelValue', 'click'])

// Reactive data
const inputRef = ref(null)
const displayValue = ref(props.modelValue)
const inputmaskInstance = ref(null)

// Настройка маски
onMounted(() => {
  if (inputRef.value) {
    import('inputmask').then(({ default: Inputmask }) => {
      inputmaskInstance.value = new Inputmask(props.mask)
      inputmaskInstance.value.mask(inputRef.value)
    })
  }
})

onUnmounted(() => {
  if (inputmaskInstance.value) {
    inputmaskInstance.value.remove()
  }
})

// Watchers
watch(() => props.modelValue, (newValue) => {
  if (newValue !== displayValue.value) {
    displayValue.value = newValue
    // Обновляем значение в input элементе
    if (inputRef.value) {
      inputRef.value.value = newValue
    }
  }
})

watch(() => props.mask, () => {
  if (inputRef.value && inputmaskInstance.value) {
    inputmaskInstance.value.remove()
    import('inputmask').then(({ default: Inputmask }) => {
      inputmaskInstance.value = new Inputmask(props.mask)
      inputmaskInstance.value.mask(inputRef.value)
    })
  }
})

// Methods
const handleClick = () => {
  emit('click')
}

const onInput = (e) => {
  const value = e.target.value
  displayValue.value = value
  emit('update:modelValue', value)
}
</script>
